function checkElements() {
    document.querySelectorAll('.fade-in-out').forEach((el) => {
        const rect = el.getBoundingClientRect();
        if (rect.top <
            window.innerHeight &&
            rect.bottom >
            window.innerHeight *
            0.3) {
            el.classList.add('fade-in');
        } else {
            el.classList.remove('fade-in');
        }
    });
}

// Run the function on both load and scroll
window.addEventListener('load', checkElements);
window.addEventListener('scroll', checkElements);
//# sourceMappingURL=storytelling.js.map
